class FreeShippingBar extends HTMLElement {
  constructor() {
    super();
    const baseThreshold = parseFloat(this.getAttribute('threshold')) || 75;
    this.threshold = Math.round(baseThreshold * 100 * (window.Shopify?.currency?.rate || 1));
    this.requestId = 0;
  }

  connectedCallback() {
    this.messageEl = this.querySelector('.free-shipping-text');
    this.progressEl = this.querySelector('.free-shipping-progress');
    if (!this.messageEl || !this.progressEl) return;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const total = this.merchandiseTotal(event.cartData);
        if (Number.isFinite(total)) {
          this.requestId += 1;
          this.updateProgress(total);
        } else {
          this.updateFromCart();
        }
      });
    }
    this.updateFromCart();
  }

  disconnectedCallback() {
    this.unsubscribe?.();
    this.requestId += 1;
  }

  merchandiseTotal(cart) {
    if (Number.isFinite(cart?.original_total_price) && Number.isFinite(cart?.total_discount)) {
      return Math.max(0, cart.original_total_price - cart.total_discount);
    }
    if (Array.isArray(cart?.items) && cart.items.every((item) => Number.isFinite(item.final_line_price))) {
      return cart.items.reduce((total, item) => total + item.final_line_price, 0);
    }
    const renderedTotal = this.getAttribute('data-cart-total');
    return renderedTotal === null ? NaN : Number(renderedTotal);
  }

  updateFromCart() {
    const requestId = ++this.requestId;
    const root = window.Shopify?.routes?.root || '/';
    return fetch(root + 'cart.js')
      .then((res) => {
        if (!res.ok) throw new Error('Cart refresh failed');
        return res.json();
      })
      .then((cart) => {
        if (requestId === this.requestId && this.isConnected) {
          this.updateProgress(this.merchandiseTotal(cart));
        }
      })
      .catch(() => {});
  }

  updateProgress(cartTotal) {
    const amountLeft = Math.max(this.threshold - cartTotal, 0);
    const percent = Math.max(0, Math.min((cartTotal / this.threshold) * 100, 100));
    const amount = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR',
    }).format(amountLeft / 100);
    this.messageEl.textContent = amountLeft > 0
      ? window.ShippingProgress.free_shipping_remaining.replace('{{ amount }}', amount)
      : window.ShippingProgress.free_shipping_qualified;
    this.progressEl.style.width = percent + '%';
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}
